import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logTrackingEvent } from '@/services/trackingService';

/**
 * Hook to track PageView events on route changes for Meta Pixel
 * This is essential for Single Page Applications (SPA) like React
 * to ensure each page navigation is tracked properly.
 */
export const usePageViewTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Track PageView whenever the route changes
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'PageView');
      console.log('Meta Pixel PageView tracked for:', location.pathname);
    }
    
    // Log to PocketBase tracking
    logTrackingEvent({
      event_type: 'PageView',
      event_id: `PageView_${Date.now()}`,
      page_url: window.location.href,
      source: 'browser',
      metadata: { pathname: location.pathname }
    });
  }, [location.pathname]);
};
